/**
 * Gets all product entry number from the `shipments` array
 * @param shipments {array}
 */
const extractEntriesNumber = <T>(shipments: T): any[] => {
  return ((shipments || []) as any[]).reduce(
    (entryNumbers: number[], { entries, sellersEntries }: any) => {
      if (entries) {
        return [...entryNumbers, ...entries.map((i: any) => i.entryNumber)];
      } else if (sellersEntries) {
        return [
          ...entryNumbers,
          ...sellersEntries.reduce(
            (sellersEntryNumbers: number[], { entries: sellersItems }: any) => [
              ...sellersEntryNumbers,
              ...sellersItems.map((i: any) => i.entryNumber),
            ],
            []
          ),
        ];
      }
      return entryNumbers;
    },
    []
  );
};

export default extractEntriesNumber;

/**
 * Gets all product entry number & offer from the `shipments` array
 * @param shipments {array}
 */
export const extractProductOffers = <T>(shipments: T): any[] => {
  return ((shipments || []) as any[]).reduce(
    (productOffers: any[], { entries, sellersEntries }: any) => {
      if (entries && entries.length) {
        return [
          ...productOffers,
          ...entries.map((i: any) => ({
            productId: i.entryNumber,
            productCode: i.product && i.product.code,
            offerId: i.offerId ? `offer_${i.offerId}` : null,
          })),
        ];
      } else if (sellersEntries && sellersEntries.length) {
        return [
          ...productOffers,
          ...sellersEntries.reduce(
            (sellersEntryNumbers: number[], { entries: sellersItems }: any) => [
              ...sellersEntryNumbers,
              ...sellersItems.map((i: any) => ({
                productId: i.entryNumber,
                productCode: i.product && i.product.code,
                offerId: i.offerId ? `offer_${i.offerId}` : null,
              })),
            ],
            []
          ),
        ];
      }
      return productOffers;
    },
    []
  );
};
